module.exports = __webpack_public_path__ + "assets/img/tx13g_2.64505ec6.jpg";